module.exports = angular.module('cartographer.plugin.layer.salmon-trout', [])

module.exports.run $DI (
  crtLog
  crtLayer
  crtFeatureLayer
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
  crtMarkerColor
) ->
  color1 = crtMarkerColor.create("#891200")
  color2 = crtMarkerColor.create("#c62c2c")
  color3 = crtMarkerColor.create("#d57025")
  color4 = crtMarkerColor.create("#e5aa16")
  color5 = crtMarkerColor.create("#8dba38")

  smartRivers = crtFeatureLayer.create({
    id: "StSmartRivers"
    name: "SmartRivers"
    atlasMapId: "StSmartRivers"
    defaultMapEngine: "atlas"
    selectionRadius: 10
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("location", "Location", [
        crtAttributeLayer.createAutoLookup("catchment", "Catchment")
        crtAttributeLayer.createAutoLookup("river", "River")
        crtAttributeLayer.createAutoLookup("site", "Site")
        crtAttributeLayer.createAutoThreshold("trpiRiverType", "TRPI River Type")
        crtAttributeLayer.createLookup("season", "Season", null, [
          { value: "Spring", label: "Spring", color: crtMarkerColor.create("lime") }
          { value: "Autumn", label: "Autumn", color: crtMarkerColor.create("orange") }
        ])
      ])
      crtFeatureLayer.createAttributeGroup("calculations", "Calculations", [
        # This index is "rounded down" if the value is 20,40,etc,
        # so we use 21,41,etc as the threshold for each bucket:
        crtAttributeLayer.createRange("psi", "PSI (Sedimentation Pressure)", null, [
          { minValue:  0, maxValue:  21, label: "Heavily Sedimented"     , color: color1 }
          { minValue: 21, maxValue:  41, label: "Sedimented"             , color: color2 }
          { minValue: 41, maxValue:  61, label: "Moderately Sedimented"  , color: color3 }
          { minValue: 61, maxValue:  81, label: "Slightly Sedimented"    , color: color4 }
          { minValue: 81, maxValue: 101, label: "Naturally/Unsedimented" , color: color5 }
        ])
        # This index is "rounded down" if the value is 20,40,etc,
        # so we use 21,41,etc as the threshold for each bucket:
        crtAttributeLayer.createRange("trpi", "TRPI (Phosphorus Enrichment Pressure)", null, [
          { minValue:  0, maxValue:  21, label: "Very high" , color: color1 }
          { minValue: 21, maxValue:  41, label: "High"      , color: color2 }
          { minValue: 41, maxValue:  61, label: "Moderate"  , color: color3 }
          { minValue: 61, maxValue:  81, label: "Low"       , color: color4 }
          { minValue: 81, maxValue: 101, label: "Very low"  , color: color5 }
        ])
        # This index is "rounded down" if the value is 20,40,etc,
        # so we use 21,41,etc as the threshold for each bucket:
        crtAttributeLayer.createRange("spear", "SPEAR (Chemical Pressure)", null, [
          { minValue:  0, maxValue:  11, label: "Bad (Heavily Impacted)" , color: color1 }
          { minValue: 11, maxValue:  22, label: "Poor"                   , color: color2 }
          { minValue: 22, maxValue:  33, label: "Moderate"               , color: color3 }
          { minValue: 33, maxValue:  44, label: "Good"                   , color: color4 }
          { minValue: 44, maxValue: 101, label: "High (Unimpacted)"      , color: color5 }
        ])
        crtAttributeLayer.createRange("si", "Saprobic (Organic Enrichment Pressure)", null, [
          { minValue:   0, maxValue: 1.8, label: "Minimal Organic Loading"  , color: color5 }
          { minValue: 1.8, maxValue: 2.3, label: "Mild Organic Loading"     , color: color4 }
          { minValue: 2.3, maxValue: 2.7, label: "Moderate Organic Loading" , color: color3 }
          { minValue: 2.7, maxValue: 3.2, label: "Strong Organic Loading"   , color: color2 }
          { minValue: 3.2, maxValue: 4.0, label: "Extreme Organic Loading"  , color: color1 }
        ])
        crtAttributeLayer.createRange("life", "LIFE (Flow Related Pressure)", null, [
          { minValue: undefined , maxValue: 6         , label: "Heavily Impacted"    , color: color1 }
          { minValue: 6         , maxValue: 6.5       , label: "Impacted"            , color: color2 }
          { minValue: 6.5       , maxValue: 7         , label: "Moderately Impacted" , color: color3 }
          { minValue: 7         , maxValue: 8         , label: "Slightly Impacted"   , color: color4 }
          { minValue: 8         , maxValue: undefined , label: "Unimpacted"          , color: color5 }
        ])
        crtAttributeLayer.createRange("bmwp", "BMWP", null, [
          { minValue:  0 , maxValue: 13        , label: "Heavily Impacted"    , color: color5 }
          { minValue: 13 , maxValue: 36        , label: "Impacted"            , color: color4 }
          { minValue: 36 , maxValue: 51        , label: "Moderately Impacted" , color: color3 }
          { minValue: 51 , maxValue: 71        , label: "Slightly Impacted"   , color: color2 }
          { minValue: 71 , maxValue: undefined , label: "Unimpacted"          , color: color1 }
        ])
        crtAttributeLayer.createAutoThreshold("cci", "CCI")
        crtAttributeLayer.createAutoThreshold("aspt", "ASPT")
        crtAttributeLayer.createAutoThreshold("ntaxa", "NTAXA")
        crtAttributeLayer.createAutoThreshold("eptSp", "EPT sp (taxa)")
        crtAttributeLayer.createAutoThreshold("eptAb", "EPT ab")
        crtAttributeLayer.createAutoThreshold("totalAb", "TOTAL ab")
        crtAttributeLayer.createAutoThreshold("whpt", "WHPT")
        crtAttributeLayer.createAutoThreshold("whptAspt", "WHPT ASPT")
      ])
    ]
  })

  smartRiversSite = crtFeatureLayer.create({
    id: "StSmartRiversSite"
    name: "SmartRivers Sites"
    atlasMapId: "StSmartRiversSite"
    defaultMapEngine: "atlas"
    selectionRadius: 10
    attributeGroups: [
      crtFeatureLayer.createAttributeGroup("location", "Location", [
        crtAttributeLayer.createAutoLookup("catchment", "Catchment")
        crtAttributeLayer.createAutoLookup("river", "River")
        crtAttributeLayer.createAutoLookup("site", "Site")
        crtAttributeLayer.createAutoThreshold("trpiRiverType", "TRPI River Type")
      ])
    ]
  })

  crtLayer.registerPlugin(smartRivers)
  crtLayer.registerPlugin(smartRiversSite)

  return
